import axiosInstance from '../../../config/axiosInstance';
import { JobSummaryValidation } from "../View/Validation/JobSummaryValidation";

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  const formErrors = JobSummaryValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.IssueCreatorUserID=UserID;
      const CompanyName=localStorage.getItem("CompanyName");
      formData.CompanyName=CompanyName;
      
      const response = await axiosInstance.post(`/Job/CreateJobSummary`, formData);
     localStorage.setItem('JobID', response.data.JobID);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleSubmit };